import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=9b4bceaa&"
import script from "./MovieList.vue?vue&type=script&lang=js&"
export * from "./MovieList.vue?vue&type=script&lang=js&"
import style0 from "./MovieList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports